import ResetPassword from './container'


export default ResetPassword
